// We use  'requestId' of VerifySession.
export const grantEndpoint = '/authentication-ms/v1/data/grant';
